import React, { useMemo } from "react";
import Style from "./index.module.scss";

import { CourseWareTypeList } from "../../../../../../../../../utils/common";
const icons = {
    ppt: require("./img/icon1.png"),
    word: require("./img/icon2.png"),
    excel: require("./img/icon3.png"),
    pdf: require("./img/icon5.png"),
    video: require("./img/icon4.png"),
    polyv: require("./img/icon4.png"),
    pic: require("./img/icon6.png"),
    href: require("./img/href.png"),
    txt: require("./img/txt.png"),
    file: require("./img/file.png"),
    compression: require("./img/compression.png")
};

interface FileIconProps {
    ext: string;
}

export default function FileIcon({ ext }: FileIconProps) {
    const extName = useMemo<keyof typeof icons>(
        () => ext.toLocaleLowerCase() as any,
        [ext]
    );

    if (CourseWareTypeList.ppt.includes(extName))
        return <img src={icons.ppt} alt="ppt" className={Style.root} />;
    if (CourseWareTypeList.word.includes(extName))
        return <img src={icons.word} alt="word" className={Style.root} />;
    if (CourseWareTypeList.excel.includes(extName))
        return <img src={icons.excel} alt="excel" className={Style.root} />;
    if (CourseWareTypeList.pdf.includes(extName))
        return <img src={icons.pdf} alt="pdf" className={Style.root} />;
    if (CourseWareTypeList.video.includes(extName))
        return <img src={icons.video} alt="video" className={Style.root} />;
    if (CourseWareTypeList.polyv.includes(extName))
        return <img src={icons.polyv} alt="polyv" className={Style.root} />;
    if (CourseWareTypeList.pic.includes(extName))
        return <img src={icons.pic} alt="pic" className={Style.root} />;
    if (CourseWareTypeList.href.includes(extName))
        return <img src={icons.href} alt="href" className={Style.root} />;
    if (CourseWareTypeList.txt.includes(extName))
        return <img src={icons.txt} alt="txt" className={Style.root} />;
    if (CourseWareTypeList.compression.includes(extName))
        return (
            <img
                src={icons.compression}
                alt="compression"
                className={Style.root}
            />
        );

    return <img src={icons.file} alt="file" className={Style.root} />;
}
